module.exports = __webpack_public_path__ + "media/img/clients/client10-5ec098a6ce52269d3d47120578754f70.svg";